import api from './client'
import type { GoogleCalendarConnectionStatus } from '../api'

export const googleCalendarApi = {
  status: async (): Promise<GoogleCalendarConnectionStatus> => {
    const response = await api.get<GoogleCalendarConnectionStatus>('/integrations/google')
    return response.data
  },

  connect: async (): Promise<{ url: string }> => {
    const response = await api.post<{ url: string }>('/integrations/google/connect')
    return response.data
  },

  disconnect: async (): Promise<GoogleCalendarConnectionStatus> => {
    const response = await api.delete<GoogleCalendarConnectionStatus>('/integrations/google')
    return response.data
  },
}
